import { render, staticRenderFns } from "./BottomSheetPictureEditor.vue?vue&type=template&id=0c2dc975&scoped=true&"
import script from "./BottomSheetPictureEditor.vue?vue&type=script&lang=js&"
export * from "./BottomSheetPictureEditor.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetPictureEditor.vue?vue&type=style&index=0&id=0c2dc975&prod&lang=scss&scoped=true&"
import style1 from "./BottomSheetPictureEditor.vue?vue&type=style&index=1&id=0c2dc975&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2dc975",
  null
  
)

export default component.exports